module.exports = __webpack_public_path__ + "img/not-found.8798c3c7.png";